import React from 'react';
import { GeoPricingProvider, useGeoPricingContext } from './context/GeoPricingContext';
import PaymentCheckoutPage from './PaymentCheckoutPage';
import { usePayment } from './usePayment';
import { Loader2 } from 'lucide-react';

const CheckoutRouter = () => {
    const { isLoading: isGeoLoading, error: geoError } = useGeoPricingContext();
    const { configLoaded } = usePayment();

    // Wait for geo + payment config so we don't mount CO checkout then swap to intl
    // (that remount was duplicating subscription/methods/history GETs).
    if (isGeoLoading || !configLoaded) {
        return (
            <div className="min-h-screen bg-white flex flex-col items-center justify-center">
                <Loader2 className="w-12 h-12 text-[#1CB3B3] animate-spin mb-4" />
                <p className="text-slate-500 font-medium">Detectando región segura...</p>
            </div>
        );
    }

    if (geoError) {
        return (
            <div className="min-h-screen bg-white flex flex-col items-center justify-center p-6 text-center">
                <div className="bg-red-50 border border-red-200 p-6 rounded-2xl max-w-md">
                    <h2 className="text-red-600 font-bold text-lg mb-2">Error de conexión</h2>
                    <p className="text-slate-600 text-sm mb-4">{geoError}</p>
                    <button 
                        onClick={() => window.location.reload()}
                        className="bg-[#1CB3B3] hover:bg-[#169a9a] text-white px-4 py-2 rounded-lg font-medium"
                    >
                        Reintentar
                    </button>
                </div>
            </div>
        );
    }

    return <PaymentCheckoutPage />;
};

export const PricingManagerView = () => {
    return (
        <GeoPricingProvider>
            <CheckoutRouter />
        </GeoPricingProvider>
    );
};

export default PricingManagerView;
